import { Component, Prop, Vue } from 'vue-property-decorator'
import { Getter, Mutation } from 'vuex-class'

/**
 * Base Widget Component
 */
@Component
export default class extends Vue {
  @Getter('context/getVariable')
  getVariable!: (path: string) => any

  @Mutation('context/setVariable')
  setVariable!: (payload: { path: string, value: any }) => void

  @Prop({ type: String, required: true })
  id!: string

  @Prop({ type: String, required: true })
  name!: string
}
